// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import router from './router'
import Vue2Editor from 'vue2-editor'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
// admin component
import Topbar from './components/shared/Topbar'
import Footer from './components/shared/Footer'
import Sidebar from './components/shared/Sidebar'
import Msg from './components/shared/Msg'
import InputMsg from './components/shared/InputMsg'
import Logout from './components/shared/Logout'
import UploadFile from './components/shared/UploadFile'

// index component
import Header from './components/index/shared/Header'
import IndexFooter from './components/index/shared/Footer'
import Pagination from './components/index/shared/Pagination'
import Socialmedia from './components/index/shared/Socialmedia'
import Banner from './components/index/Module/Banner'
import IndexActivity from './components/index/Module/Activity'
import IndexNews from './components/index/Module/News'
import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

// global js
import {Mixin} from './components/js/Mixin.js'
Vue.mixin(Mixin);
Vue.use( VueMeta );
Vue.config.productionTip = false
Vue.use(Vue2Editor);
Vue.use(VueMeta);

Vue.component('Topbar', Topbar);
Vue.component('Footer', Footer);
Vue.component('Sidebar', Sidebar);
Vue.component('Logout', Logout);
Vue.component('Msg', Msg);
Vue.component('InputMsg', InputMsg);
Vue.component('UploadFile', UploadFile);

Vue.component('Header', Header);
Vue.component('IndexFooter', IndexFooter);
Vue.component('Socialmedia', Socialmedia);
Vue.component('Banner', Banner);
Vue.component('IndexActivity', IndexActivity);
Vue.component('IndexNews', IndexNews);
Vue.component('Loading', Loading);
Vue.component('Pagination', Pagination);
/* eslint-disable no-new */
import i18n from './lang/vue-i18n.js'

new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js